<template lang="pug">
v-form
  ParticipationCircleFields
  OrganizerFields
  v-row.mt-8
    v-col(cols="12")
      Subtitle(
        :text="t$('.location')",
        :fontSize="1.2",
        :fontWeight="900"
      )
    v-col(cols="12")
      EventFormAddressField
    v-col(cols="12")
      OnlineConferenceField
  PublishingFields
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { PanelIdentifier } from "features/events/form/event-form.types"
import { PanelDefinition } from "features/events/form/FormExpansionPanel.vue"
import useTranslate from "features/common/translate/concerns/useTranslate"
import Subtitle from "components/UI/Subtitle.vue"
import OnlineConferenceField from "features/events/form/general-fields/OnlineConferenceField.vue"
import ParticipationCircleFields from "features/events/form/general-fields/ParticipationCircleFields.vue"
import OrganizerFields from "components/EventForm/OrganizerFields.vue"
import PublishingFields from "components/EventForm/PublishingFields.vue"
import EventFormAddressField from "features/events/form/general-fields/EventFormAddressField.vue"

const OrganiaztionFields = defineComponent({
  name: "OrganizationFields",
  components: {
    PublishingFields,
    OrganizerFields,
    ParticipationCircleFields,
    OnlineConferenceField,
    EventFormAddressField,
    Subtitle,
  },
  setup() {
    const { t$ } = useTranslate("components.event_form")

    return {
      t$,
    }
  },
})

export default OrganiaztionFields

export const OrganizationFieldsDefinition: PanelDefinition = {
  key: "organization",
  component: OrganiaztionFields,
  id: PanelIdentifier.ORGANIZATION,
}
</script>
